<template>
    <div class="body-box">
        <div class="header">
            <div class="title">
                <span>量体数据（共{{total}}条）</span>
            </div>
            <div class="flex align-center">
                <div class="search-box">
                    <input placeholder="输入信息搜索" v-model="keyword"/>
                    <div class="search" @click="search">搜索</div>
                </div>
                <span @click="add">+ 新增量体</span>
            </div>

        </div>

        <div class="body-data">
            <div class="header">
                <div class="item">姓名</div>
                <div class="item">手机号</div>
                <div class="item">身高</div>
                <div class="item">体重</div>
                <div class="item">生日</div>
                <div class="action">操作</div>
            </div>
            <div v-for="(item,index) in list" :key="index" class="item-box">
                <div class="item">{{ item.name }}</div>
                <div class="item">{{ item.mobile }}</div>
                <div class="item">{{ item.height }}</div>
                <div class="item">{{ item.weight }}</div>
                <div class="item">{{ item.birthday }}</div>
                <div class="action">
                    <div class="edit" @click="view(item.id)">数据记录</div>
                    <div class="del" @click="del(index,item.id)">删除数据</div>
                </div>
            </div>
        </div>
        <Page :current="page" :total="total" :page-size="size" @on-change="changePage" show-total
              style="margin-top: 20px;" show-sizer @on-page-size-change="changeSize"
              :page-size-opts="[5, 10, 20]"></Page>

    </div>
</template>

<script>
    import {
        getFigureList,
        deleteFigure
    } from "@/api"

    export default {
        name: '',
        components: {},
        data() {
            return {
                page: 1,
                total: -1,
                size: 5,
                keyword: '',
                list: []
            };
        },
        created() {
            this.getList()
        },
        methods: {
            changePage(page) {
                this.page = page
                this.getList()
            },
            changeSize(size) {
                this.page = 1
                this.size = size
                this.getList()
            },
            async getList() {
                let json = await getFigureList({page: this.page, size: this.size, keyword: this.keyword})
                this.list = json.data.list
                this.total = json.data.total
            },

            add() {
                this.$router.push({
                    name: 'FigureBodyForm'
                })
            },
            view(id) {
                this.$router.push({
                    name: "FigureBodyDetail",
                    query: {id: id}
                })
            },
            del(index, id) {
                deleteFigure({id: id}).then(() => {
                    this.list.splice(index, 1)
                })

            },
            search() {
				this.page = 1
                this.getList()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .body-box {
        width: 950px;
        background: #FFFFFF;
        padding: 20px;

        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #0F114A;
            font-size: 17px;
            font-weight: bold;

            .search-box {
                width: 300px;
                height: 34px;
                border: 1px solid #B3B3B3;
                display: flex;
                align-items: center;

                input {
                    width: 240px;
                    height: 30px;
                    border: none;
                    padding-left: 10px;

                }

                .search {
                    border-left: 1px solid #B3B3B3;
                    width: 60px;
                    line-height: 34px;
                    height: 34px;
                    font-size: 15px;
                    font-weight: 400;
                    color: #676767;
                    text-align: center;
                    cursor: pointer;
                }
            }
        }


        .body-data {
            background: #FFFFFF;
            border: 1px solid #EEEEEE;
            margin-top: 20px;
            font-size: 13px;

            .header {
                background: #F5F5F5;
                height: 40px;
                line-height: 40px;
            }

            .header {
                .item {
                    height: 40px;
                    line-height: 40px;
                    color: #333333;
                }
            }

            .item-box {
                height: 97px;
                line-height: 97px;
                background: #FFFFFF;
                border-bottom: 1px solid #DDDDDD;

                .item {
                    height: 97px;
                    line-height: 97px;
                }
            }

            .item-box {
                .action {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    text-align: center;

                    .edit {
                        width: 72px;
                        height: 24px;
                        line-height: 24px;
                        background: #0F114A;
                        border-radius: 3px;
                        font-size: 13px;
                        color: #EDD4AC;
                        cursor: pointer;
                    }

                    .del {
                        width: 72px;
                        height: 24px;
                        line-height: 24px;
                        font-size: 13px;
                        color: #333333;
                        cursor: pointer;
                        border: 1px solid #0F114A;
                        border-radius: 3px;
                        color: #0F114A;
                        margin-top: 10px;
                    }
                }
            }

            .item-box:last-child {
                border: none;
            }

            .item-box,
            .header {
                display: flex;

                .item {
                    width: 154px;
                    padding-left: 20px;
                }

                .action {
                    width: 139px;
                    padding-left: 20px;
                }
            }

        }

    }
</style>
